import { createFileRoute } from '@tanstack/react-router'
import BillingRunHistoryDetail from '@/pages/BillingRunHistory/BillingRunHistoryDetail'
import { RequirePermission } from '@/components/ui/require-permission'

export const Route = createFileRoute(
  '/_authenticated/operation/billing-run-history/$runId'
)({
  component: () => (
    <RequirePermission permission='billing.run'>
      <BillingRunHistoryDetail />
    </RequirePermission>
  ),
})
